/**
 * Rotation automatique des badges produit (promo + badges de collections).
 *
 * Quand un conteneur .massin-product-corner-badges contient au moins deux
 * badges visibles (le badge promo et/ou des badges de collections activés
 * par la section « Badges de collections »), les badges sont superposés et
 * affichés un par un, en boucle, avec un fondu (voir massin-sections.css,
 * classes .massin-badges-rotating / .is-badge-active).
 *
 * Respecte prefers-reduced-motion : dans ce cas les badges restent empilés.
 */
(() => {
  const ROTATION_INTERVAL_MS = 3000;
  const CONTAINER_SELECTOR = '.massin-product-corner-badges';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const rotators = new Set();
  let tickerId = null;

  const isBadgeVisible = (el) => {
    if (!el.classList.contains('massin-promo-metafield-flag')) return false;
    const style = window.getComputedStyle(el);
    if (style.display === 'none') return false;
    // Un emplacement de badge de collection n'est réellement configuré que
    // si la section « Badges de collections » lui a donné une image de fond.
    if (el.classList.contains('massin-collection-badge') && style.backgroundImage === 'none') {
      return false;
    }
    return true;
  };

  const tick = () => {
    rotators.forEach((rotator) => {
      if (!rotator.container.isConnected) {
        rotators.delete(rotator);
        return;
      }
      rotator.badges[rotator.index].classList.remove('is-badge-active');
      rotator.index = (rotator.index + 1) % rotator.badges.length;
      rotator.badges[rotator.index].classList.add('is-badge-active');
    });
    if (rotators.size === 0 && tickerId !== null) {
      clearInterval(tickerId);
      tickerId = null;
    }
  };

  const setupContainer = (container) => {
    if (container.dataset.massinBadgeRotator) return;
    container.dataset.massinBadgeRotator = 'true';

    const badges = Array.from(container.children).filter(isBadgeVisible);
    if (badges.length < 2) return;

    container.classList.add('massin-badges-rotating');
    badges.forEach((badge, i) => badge.classList.toggle('is-badge-active', i === 0));
    rotators.add({ container, badges, index: 0 });

    if (tickerId === null) {
      tickerId = setInterval(tick, ROTATION_INTERVAL_MS);
    }
  };

  const scan = (root) => {
    if (!(root instanceof Element) && root !== document) return;
    if (root instanceof Element && root.matches(CONTAINER_SELECTOR)) {
      setupContainer(root);
    }
    root.querySelectorAll(CONTAINER_SELECTOR).forEach(setupContainer);
  };

  const init = () => {
    scan(document);

    // Surfaces rendues dynamiquement : recherche prédictive, tiroir panier,
    // notification panier, rechargements de sections (éditeur de thème)…
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => scan(node));
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
